export default __webpack_public_path__ + "static/webRotator/svg/395b950ce3f5009bd7bd0d3c90679f82.svg";